import { formatSide, DEFAULT_LOCALE, type SupportedLocale } from "@patient-watch/i18n";

export type TrackerSide = string | null | undefined;

function capitalizeFormName(formName: string): string {
    return formName
        .split(" ")
        .map((word) => (word.length > 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word))
        .join(" ");
}

/** Form name with laterality suffix when the tracker is left or right sided. */
export function formatTrackerDisplayTitle(
    formName: string | null | undefined,
    side: TrackerSide,
    fallback = "Questionnaire",
    locale: SupportedLocale = DEFAULT_LOCALE
): string {
    const name = capitalizeFormName(formName?.trim() || fallback);
    if (side === "Left" || side === "Right") {
        return `${name} - ${formatSide(side, locale)}`;
    }
    return name;
}
